<template>
  <div class="upload" v-loading="loading">
    <el-upload
      :class="[
        'avatar-uploader',
        { hidden: model.includes('rar') || model.includes('zip') },
      ]"
      :accept="acceptType"
      action="/app/file/upload"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :show-file-list="false"
    >
      <div class="content" :style="{ width: width, height: height }">
        <div v-if="!isCheck" class="uoload-btn">
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <div class="upload-text">{{ cardTitle }}</div>
        </div>
      </div>
    </el-upload>
    <template v-if="model || isCheck">
      <template v-if="model.includes('rar') || model.includes('zip')">
        <div class="rar_css">
          <img
            style="width: 128px; height: 128px"
            src="~@/assets/images/uploadImg/file_icon2.png"
          />
          <el-link
            :underline="false"
            type="primary"
            @click="downloadFile(model)"
          >
            <p>下载附件</p>
          </el-link>
          <i
            v-if="!this.isCheck"
            @click="handleRemoveImage(model)"
            class="e6-icon-delete_line btn-cancle-img"
          ></i>
        </div>
      </template>
      <template v-if="!model.includes('rar') && !model.includes('zip')">
        <e6-image
          :src="model"
          class="avatar"
          :preview-src-list="[model]"
        ></e6-image>
        <i
          v-if="!this.isCheck"
          @click="handleRemoveImage(model)"
          class="e6-icon-delete_line btn-cancle-img"
        ></i>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "uploadImg",
  model: {
    prop: "model",
    event: "change",
  },
  props: {
    model: {
      type: String,
    },
    type: {
      type: String,
      default: "add",
    },
    cardTitle: {
      type: String,
      default: "上传图片",
    },
    width: {
      type: String,
      default: "200px",
    },
    height: {
      type: String,
      default: "200px",
    },
    interval: {
      type: String,
      default: "20px",
    },
    fileType: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      function() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      isRemove: false,
      isCheck: false,
      acceptType: ".jpg,.jpeg,.png,.bmp",
      hideImg: false,
    };
  },
  // computed: {
  //   action() {
  //     // let url = "http://cc.gdccpsmp.cn/app/file/upload";
  //     // if (this.$GLOBAL_CONFIG.imageDirName == "zhengzhou") {
  //     //   url = "http://jk.hnlenglian.com/app/file/upload";
  //     // }
  //     return url;
  //   }
  // },
  created() {
    if (this.fileType) {
      this.acceptType = `${this.acceptType},${this.fileType}`;
    }
    if (this.type === "check") {
      this.isCheck = true;
    }
  },
  methods: {
    handleBeforeUpload(file) {
      this.loading = true;
      let isPNG = file.type == "image/png" ? true : false;
      let isjpg = file.type == "image/jpeg" ? true : false;
      if (!(isPNG || isjpg)) {
        this.loading = false;
        this.$message.warning("请上传jpg/png文件!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.warning("上传文件大小不能超过 20B!");
        this.loading = false;
        return false;
      }
    },
    handleSuccess(res) {
      if (res.code) {
        let fileUrl = "";
        if (res.code === 1) {
          fileUrl = res.result.filename || "";
        }
        if (fileUrl) {
          this.loading = false;
          this.isRemove = true;
          this.$emit("change", fileUrl);
          let data = {
            PictureUrl: fileUrl,
          };
          this.$emit("callback", data);
        }
      } else {
        this.loading = false;
        this.$message.error(res.message);
      }
    },

    handleError() {
      this.loading = false;
      this.$message.error("上传图片失败");
    },
    handleRemoveImage(val) {
      if (this.type == "update") {
        this.isRemove = true;
      }
      this.$emit("removeUrl", val);
      this.$emit("change", "");

      // this.uploadType = "image";
    },
    downloadFile(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  .upload-title {
    padding: 5px;
  }
  .avatar-uploader {
    width: 100%;
    height: 100%;
    /deep/ .el-upload {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px dashed #ccc;
      border-radius: 5px;
      .content {
        position: relative;
        .upload-text {
          margin-top: 5px;
          color: #e5e5e5;
          font-size: 18px;
        }
        .uoload-btn {
          position: absolute;
          width: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .el-icon-plus {
        font-size: 50px;
        color: #e5e5e5;
      }
    }
  }
  .e6-image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .e6-icon-delete_line {
    position: absolute;
    top: -7px;
    right: -10px;
    background: red;
    width: 21px;
    height: 21px;
    line-height: 21px;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
  }
}
.rar_css {
  width: 150px;
  word-break: break-all;
  position: relative;
  .e6-icon-delete_line {
    position: absolute;
    top: 0;
    right: -25px;
  }
  .file_icon {
    display: inline-block;
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    left: -18px;
    background: url("~@/assets/images/uploadImg/file_icon.png") no-repeat;
  }
  .el-link {
    text-align: initial;
  }
}
.hidden {
  display: none;
}
</style>
